import React from 'react'
import ArrowRightSvg from 'images/modules/Shared/i-arrow-right-agent.svg?raw'

export { default as ArrowRightAgentUrl } from 'images/modules/Shared/i-arrow-right-agent.svg'

export default props => (
  <span {...props} dangerouslySetInnerHTML={{__html: ArrowRightSvg}} />
)
